import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import KnewtonChatButton from '../knewton-chat/KnewtonChatButton';

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-bg-primary">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Navigation */}
      <MobileNav />

      {/* Main Content Area */}
      <div className="lg:pl-64">
        {/* Mobile top spacing */}
        <div className="lg:hidden h-16" />

        {/* Page Content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8 pb-20">
          <Outlet />
        </main>

        {/* Footer Disclaimer */}
        <footer className="fixed bottom-0 left-0 right-0 lg:left-64 bg-bg-secondary/95 backdrop-blur-sm border-t border-border py-2 px-4 z-30">
          <p className="text-[10px] text-text-tertiary text-center max-w-4xl mx-auto">
            This site is for informational and entertainment purposes only. Must be 21+ in most jurisdictions.
            Gambling involves risk. If you choose to wager, do so responsibly and at your own risk.
            {' '}<a href="https://www.ncpgambling.org" target="_blank" rel="noopener noreferrer" className="underline hover:text-text-secondary">
              Problem Gambling Help: 1-800-522-4700
            </a>
          </p>
        </footer>
      </div>

      {/* Knewton Chat Button (Premium Feature) */}
      <KnewtonChatButton />
    </div>
  );
}
